import icon from './Assets/icons.svg';

// @ts-ignore
const Icon = ({ id, ...props}) => (
    <svg {...props} fill='currentColor'>
        <use xlinkHref={`${icon}#${id}`}></use>
    </svg>
)

export default Icon;